document.addEventListener("DOMContentLoaded", function () {
  const apiKey = "WTCOPEMSXZNUXAH5QX";
  const endpoint = `https://www.eventbriteapi.com/v3/users/me/events/?token=${apiKey}`;

  fetch(endpoint)
    .then((response) => response.json())
    .then((data) => {
      const eventContainer = document.getElementById("event-container");

      if (!eventContainer) return;

      data.events.forEach((event) => {
        const eventDiv = document.createElement("div");
        eventDiv.className = "event";

        const eventTitle = document.createElement("h3");
        eventTitle.textContent = event.name.text;
        eventTitle.className = "event-title";

        const eventDate = document.createElement("p");
        eventDate.textContent = new Date(event.start.utc).toLocaleString();
        eventDate.className = "event-date";

        eventDiv.appendChild(eventTitle);
        eventDiv.appendChild(eventDate);
        eventContainer.appendChild(eventDiv);
      });
    })
    .catch((error) => console.error("Error fetching events:", error));
});

